<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>Insérez le logo de votre compagnie, visible par tous les utilisateurs.</span>
      </div>
    </div>

    <div class="ov-card logo-card">
      <div class="ov-card__head">
        <div>
          <div class="ov-card__title">Importer le logo</div>
          <div class="ov-card__sub">Formats acceptés : PNG, JPEG</div>
        </div>
        <div class="logo-formats">
          <span class="ov-badge ov-badge--navy ov-badge--plain">PNG</span>
          <span class="ov-badge ov-badge--navy ov-badge--plain">JPG</span>
        </div>
      </div>

      <div class="ov-card__body">
        <div class="ov-label">{{ logoTransportInBase64 ? 'Aperçu du logo' : 'Aucun logo' }}</div>
        <div
          class="logo-drop"
          :class="{ 'logo-drop--filled': logoTransportInBase64 }"
          @click="!logoTransportInBase64 && $refs.fileInput.click()"
        >
          <button
            v-if="logoTransportSelected || logoTransportInBase64"
            type="button"
            class="ov-icon-btn ov-icon-btn--danger logo-drop__delete"
            @click.stop="clearFile"
          >
            <v-icon small>mdi-close</v-icon>
          </button>
          <img v-if="logoTransportInBase64" :src="logoTransportInBase64" class="logo-drop__img" alt="Logo" />
          <div v-else class="logo-drop__placeholder">
            <v-icon size="32">mdi-image-plus</v-icon>
            <span>Cliquez pour sélectionner une image</span>
            <small>PNG ou JPEG · Taille recommandée : 512×512 px</small>
          </div>
        </div>
        <div v-if="logoTransportSelected" class="ov-hint logo-drop__name">
          {{ logoTransportSelected.name }} · {{ (logoTransportSelected.size / 1024).toFixed(1) }} Ko
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/jpeg, image/png"
          style="display: none"
          @click="$event.target.value = ''"
          @change="logoTransportSelected = $event.target.files[0] || null; convertirEnBase64(logoTransportSelected)"
        />
      </div>

      <div class="ov-card__foot">
        <button
          v-if="logoTransportSelected"
          type="button"
          class="ov-btn ov-btn--secondary"
          @click="clearFile"
        >
          <v-icon small>mdi-refresh</v-icon>
          Changer
        </button>
        <button
          type="button"
          class="ov-btn ov-btn--primary"
          :disabled="!logoTransportSelected || !logoTransportInBase64"
          @click="sendLogoTransport"
        >
          <v-icon small>mdi-content-save</v-icon>
          Enregistrer
        </button>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  API_SEND_DOCUMENTS,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import axios from "axios";
import { showErrorMessage, showSuccessMessage } from "../messages/messageProcess";
export default {
  name: "LogoCompagnieTransport",

  data() {
    return {
      errorMsg: null,
      successMsg: null,
      overlay: false,

      logoTransportSelected: null,
      logoTransportInBase64: "",

      documentToSend: {
        datas: [],
      },

      logoTransportDocumentModel: {
        compagnieTransportRaisonSociale: null,
        typeDocument: null,
        content: null,
        typeMime: null,
      },
    };
  },

  methods: {
    clearFile() {
      this.logoTransportSelected = null;
      this.logoTransportInBase64 = "";
    },

    convertirEnBase64(file) {
      // Vidé pendant la lecture : « Enregistrer » reste désactivé tant que le fichier n'est pas entièrement lu
      this.logoTransportInBase64 = "";
      if (!file) return;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.logoTransportInBase64 = e.target.result;
      };
    },

    returnTypeMime(file) {
      var formatTypeMime = "";
      if (file.type == "image/png") {
        formatTypeMime = "FORMAT_PNG";
      }
      if (file.type == "image/jpeg") {
        formatTypeMime = "FORMAT_PNG";
      }
      if (file.type == "image/gif") {
        formatTypeMime = "FORMAT_GIF";
      }
      if (file.type == "application/pdf") {
        formatTypeMime = "FORMAT_PDF";
      }
      return formatTypeMime;
    },

    // ENVOYER DOCUMENT DE TRANSPORT
    async sendLogoTransport() {
      this.overlay = true;
      this.logoTransportDocumentModel.compagnieTransportRaisonSociale =
        this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
      this.logoTransportDocumentModel.typeDocument = "LOGO";
      this.logoTransportDocumentModel.content =
        this.logoTransportInBase64.split(",")[1];
      this.logoTransportDocumentModel.typeMime = this.returnTypeMime(
        this.logoTransportSelected
      );
      this.documentToSend.datas.push(this.logoTransportDocumentModel);
      await axios
        .post(API_SEND_DOCUMENTS, this.documentToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.successMsg = response.data.status.message;
              showSuccessMessage();
              this.documentToSend.datas = [];
              this.logoTransportSelected = null;
            } else {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
              this.documentToSend.datas = [];
              this.logoTransportSelected = null;
            }
          } else {
            this.errorMsg = "Impossible de soumettre le document";
            showErrorMessage();
            this.documentToSend.datas = [];
            this.logoTransportSelected = null;
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
          this.documentToSend.datas = [];
          this.logoTransportSelected = null;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.logo-card {
  max-width: 640px;
}

.logo-formats {
  display: flex;
  gap: 6px;
}

/* DÉPÔT DU LOGO */
.logo-drop {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  overflow: hidden;
  border: 1px dashed rgba(15, 23, 42, 0.18);
  border-radius: 12px;
  background: $ov-soft;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: $ov-green;
    background: rgba(21, 158, 114, 0.04);
  }

  &--filled {
    border-style: solid;
    border-color: $ov-line;
    background: #ffffff;
    cursor: default;
  }
}

.logo-drop__delete {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.logo-drop__img {
  display: block;
  width: 100%;
  height: 200px;
  padding: 16px;
  object-fit: contain;
  pointer-events: none;
}

.logo-drop__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: $ov-muted;
  pointer-events: none;
  user-select: none;

  small {
    font-size: 12px;
    font-weight: 500;
    color: $ov-subtle;
  }

  .v-icon {
    color: $ov-subtle !important;
  }
}

.logo-drop__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
